import React, { Component } from "react";
import { Card } from "material-ui/Card";
import { Flex } from "rebass";
import { connect } from "react-redux";
import compose from "recompose/compose";
import { showNotification as showNotificationAction } from "admin-on-rest";
import { ViewTitle } from "../../components";
import { RestApiAgencyCommissions } from "../../restClient";
import { HeaderTitleChart } from "../styled";
import AmountChart from "./AmountChart";

class CommissionsChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agencyId: props.match.params.id,
      dataAgency: []
    };
  }
  componentWillMount() {
    const { agencyId } = this.state;
    this.getChartCommissions(agencyId);
  }
  getChartCommissions = paramsId => {
    RestApiAgencyCommissions(paramsId)
      .then(response => response.json())
      .then(items => {
        // console.log(items);
        if (items && !items.message) {
          this.setState({
            dataAgency: items
          });
        } else {
          this.props.showNotification(items.message, "warning");
        }
      })
      .catch(e => {
        // console.log(e);
        this.props.showNotification("please try again", "warning");
      });
  };
  render() {
    const { dataAgency } = this.state;
    return (
      <Card containerStyle={{ minHeight: 318 }}>
        <ViewTitle title={<HeaderTitleChart {...this.props} />} />
        <Flex w={[1]} p={[1]} px={[2]}>
          <AmountChart data={dataAgency} />
        </Flex>
      </Card>
    );
  }
}

const enhance = compose(
  connect(
    (state, props) => {
      return {};
    },
    { showNotification: showNotificationAction }
  )
);

export default enhance(CommissionsChart);



// WEBPACK FOOTER //
// ./src/agency/commissions/CommissionsChart.js